// extracted by mini-css-extract-plugin
export default {"panel_container":"licenseDetailPanel_panel_container__YuajN","heading":"licenseDetailPanel_heading__wEpLO","description":"licenseDetailPanel_description__9zkUn"};